import React from 'react';

import { StyledBurger, StyledContainer } from './styles';
import { useHeaderContext } from '../../HeaderContextProvider';
import { BurgerMenuIcon } from '../../assets/BurgerMenuIcon';
import { CloseMenuIcon } from '../../assets/CloseMenuIcon';

interface TLogoAndMenuBurgerProps {
  setOpenMenu: React.Dispatch<React.SetStateAction<boolean>>;
  openMenu: boolean;
}

const LogoAndBurgerMenu = ({
  setOpenMenu,
  openMenu,
}: TLogoAndMenuBurgerProps) => {
  const { appLogo, colorsPaletteFromBO, routes } = useHeaderContext();

  return (
    <StyledContainer>
      <a href={routes.HOME}>{appLogo}</a>
      {!openMenu && (
        <StyledBurger onClick={() => setOpenMenu(true)}>
          <BurgerMenuIcon color={colorsPaletteFromBO.main} />
        </StyledBurger>
      )}
      {openMenu && (
        <StyledBurger onClick={() => setOpenMenu(false)}>
          <CloseMenuIcon color={colorsPaletteFromBO.main} size="30" />
        </StyledBurger>
      )}
    </StyledContainer>
  );
};

export default LogoAndBurgerMenu;
